<template>
  <div :id="componentId" class="spm1-event-series" :style="{ backgroundColor }">
    <div class="spm1-event-title" :style="{ backgroundColor: titleBackgroundColor }">
      <span class="spm1-event-title-text">{{ titleContent }}</span>
    </div>
    <div class="spm1-event-grid" :style="{ backgroundColor: itemBackgroundColor }">
      <a
        v-for="(item, idx) in items"
        :key="idx"
        :class="['spm1-event-item', { 'is-link': item.jumpType === 2 }]"
        href="javascript:;"
        @click.prevent="handleClick(item)"
      >
        <img class="spm1-event-image" referrerpolicy="no-referrer" :src="item.imageUrl" />
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MobileEventSeries',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_4'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      titleContent: '系列活动',
      titleBackgroundColor: 'rgba(11, 115, 96, 1)',
      itemBackgroundColor: 'rgba(245, 245, 245, 1)',
      items: [
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG97e79262cc1e0a2a7a63f7e7786c4b39.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG97e79262cc1e0a2a7a63f7e7786c4b39.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/event/2'
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG6caad4959c577c6621dddf002edc963a.png'),
          jumpType: 1,
          linkAddress: ''
        },
        {
          imageUrl: require('../../../special/SpecialOne/assets/img/FigmaDDSSlicePNG5d0afcd34128e1c76a754dcdce25ddb9.png'),
          jumpType: 2,
          linkAddress: 'https://www.example.com/event/4'
        }
      ]
    }
  },
  methods: {
    handleClick(item) {
      if (item.jumpType !== 2 || !item.linkAddress) return
      window.open(item.linkAddress, '_blank')
    }
  }
}
</script>

<style scoped>
.spm1-event-series {
  width: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.spm1-event-title {
  display: inline-block;
  padding: 4px 16px;
  border-radius: 4px;
  margin-bottom: 12px;
}

.spm1-event-title-text {
  color: #fff;
  font-size: 15px;
  font-family: Microsoft YaHei-Regular;
}

.spm1-event-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  padding: 8px;
  border-radius: 8px;
}

.spm1-event-item {
  display: block;
  width: 100%;
  border-radius: 6px;
  overflow: hidden;
  cursor: default;
  transition: opacity 0.2s;
  text-decoration: none;
}

.spm1-event-item.is-link {
  cursor: pointer;
}

.spm1-event-item.is-link:active {
  opacity: 0.85;
}

.spm1-event-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
  aspect-ratio: 294 / 211;
}
</style>
